import { toastActions } from "pickups-ui-library";

export const showToastError = () =>
  toastActions.showToast({
    message: `Sorry, we couldn't complete your request`,
    type: "error",
    // noClose: true,
  });
